<template>
	<div>
		<!-- Filter navigation -->
		<AircraftFilter
			v-if="loaded"
			:categories="tiers"
			:activeID="currentCategoryID"
			@click="setCategory"
		/>

		<!-- Helicopter cards -->
		<transition-group name="cards" tag="section" class="flex justify-centre" @before-leave="beforeLeave">
			<AircraftCard
				v-for="craft in filteredAircraft"
				:key="craft.id"
				:aircraft="craft"
				:tiers="getCraftTiers(craft)"
			/>
		</transition-group>
	</div>
</template>

<script>
import ApiService from "@/services/apiService"
import AircraftFilter from "@/components/aircraft/AircraftFilter"
import AircraftCard from "@/components/aircraft/AircraftCard"

export default {
	name: "HelicoptersList",

	components: { AircraftFilter, AircraftCard },

	data() {
		return {
			baseUrl: process.env.VUE_APP_WP_API_URL,
			loaded: false,
			aircraft: [],
			tiers: [],
			currentCategoryID: null
		}
	},

	computed: {
		/**
		 * When the category (tier) ID changes, filteredHelicopters returns a list based on that value
		 */
		filteredAircraft() {
			let vm = this
			return !vm.currentCategoryID
				? vm.aircraft
				: vm.aircraft.filter((helicopter) => helicopter["helicopter-type"].includes(vm.currentCategoryID))
		},
	},

	methods: {
		/**
		 * Fetch aircraft from WordPress API
		 */
		fetchAircraft() {
			const config = {
				baseURL: this.baseUrl,
				params: { orderby: "menu_order", order: "asc" }
			}
			return ApiService.get("helicopter", config)
		},

		/**
		 * Fetch aircraft tiers from WordPress API
		 */
		fetchTiers() {
			const config = { baseURL: this.baseUrl }
			return ApiService.get("helicopter-type", config)
		},

		/**
		 * Get the tiers for a specific aircraft
		 */
		getCraftTiers(craft) {
			return this.tiers.filter((tier) => craft["helicopter-type"].includes(tier.id))
		},

		/**
		 * Current category of aircraft
		 */
		setCategory(newID) {
			this.currentCategoryID = newID ? newID : null
		},

		/**
		 * Before aircraft category transition, set inline styles for each card
		 */
		beforeLeave(el) {
			const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)
			el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
			el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
			el.style.width = width
			el.style.height = height
		},
	},

	mounted() {
		let vm = this
		Promise.all([vm.fetchAircraft(), vm.fetchTiers()])
			.then((res) => {
				vm.aircraft = res[0].data
				vm.tiers = res[1].data
				vm.loaded = true
			})
			.catch((err) => {
				console.log("err :>> ", err)
			})
	},
}
</script>

<style lang="scss" scoped>
.cards-enter-active {
	transition: 600ms ease;
}

.cards-leave-active {
	transition: opacity 600ms ease;
	position: absolute;
}

.cards-enter,
.cards-leave-to {
	opacity: 0;
	transform: scale(0.9);
}

.cards-move {
	transition: 600ms ease;
}
</style>
